import React, { useEffect } from "react";
import { Navigate, Outlet } from "react-router-dom";

import { useSetRecoilState } from "recoil";
import { signInState } from "lib/store/user";

export const Auth = () => {
  const setIsLogged = useSetRecoilState(signInState);
  const token = localStorage.getItem("token");

  useEffect(() => {
    if (!!token) {
      setIsLogged(true);
    }
  }, [setIsLogged, token]);

  return token ? <Outlet /> : <Navigate to={"/sign-in"} />;
};
